import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const DescriptionText = styled(Typography)({
  fontFamily: 'inherit',
  margin: 0,
  whiteSpace: 'pre-wrap'
});
